import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { lineItemTitle, PageTitle } from '@/features/shared/page-title';
import { PageContentSection, PageSection, TopSection } from '@/components/layout/layout';
import { useProposalContext } from '@/features/proposals/proposal-context';
import { LineItemBreadcrumbsV2 } from '@/components/layout/breadcrumbs';
import { useCampaignContext } from '@/features/campaigns/campaign-context';
import { DraftLineItem } from '@/icons/draft-line-item';
import { Button } from '@/components/display/button';
import { useCaptureLineItemView } from '@/utils/posthog/analytics';

export function ProposalLineItemPage() {
  const { lineItemId } = useParams();
  const { campaign } = useCampaignContext();
  const { lineItems } = useProposalContext();
  const navigate = useNavigate();

  const lineItem = lineItems.find(lineItem => lineItem.id === lineItemId);
  useCaptureLineItemView(lineItem);

  if (!lineItem) {
    return <div>Line Item Not Found</div>;
  }

  const lineItemName = lineItem.name;
  return (
    <div className="flex w-full flex-col">
      <PageTitle title={lineItemTitle(lineItemName)} />
      <TopSection>
        <LineItemBreadcrumbsV2 campaign={campaign} name={lineItemName} />
      </TopSection>
      <PageSection>
        <PageContentSection>
          <div className="w-full h-full flex flex-col items-center text-gray-600">
            <div className="w-[500px] mt-8">
              <DraftLineItem />
            </div>
            <div className="text-2xl font-bold mt-8">Draft Line Item</div>
            <div className="text-lg font-light mt-4">This line item isn't ready to execute yet</div>
            <div>
              Media Plans can be created for this Line Item once it's promoted to an Execution Plan
            </div>
            <Button
              className="mt-4 cursor-pointer"
              onClick={() => navigate(`/campaigns/${campaign.campaign_id}`)}>
              Go to Campaign
            </Button>
            <div className="flex-2" />
          </div>
        </PageContentSection>
      </PageSection>
    </div>
  );
}
